var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"mention-item__mc-tip\">\n    <p>\n        This mention relates to your "
    + ((stack1 = container.invokePartial(require("./mclogo.handlebars"),depth0,{"name":"mclogo","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " <strong>Market Conduct</strong>.\n    </p>\n</section>\n";
},"usePartial":true,"useData":true});